import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { Card, CardBody, Col, Row, Input, Label, select, Text, Modal, ModalBody, Alert, FormGroup,} from "reactstrap";
import { Link } from "react-router-dom";
import moment from 'moment';

import { AppConfiguration } from "read-appsettings-json";
import { GetRequest, PostRequest } from '../../../noser-dataaccess'
import axios from 'axios'
import dateFormat from 'dateformat';
import { useNavigate } from "react-router-dom";
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Switch from "react-switch";

import AWS from "aws-sdk";
import "../../Account/jobspace-account.css"; // JobSpace design system (reskin only)


const ApplicationPage = ({ length = 6 }) => {

  const [file, setFile] = useState(null);

  const getFormattedDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return `${year}${month}${day}${hours}${minutes}${seconds}`;
  };

  const [fileType, setFiles] = useState("") 

  const inputs = useRef([])
  const navigate = useNavigate();
  const navigateSignIn = useNavigate();
  const navigateSignUp = useNavigate();
  const navigateCandidProf = useNavigate();
  const navigateSuccScreen = useNavigate();
  const navigateResume = useNavigate();
  const navigateJobPost = useNavigate();
  const navigateDirectApply = useNavigate();
  const navigateAppliedJob = useNavigate();


  const [applydisbled, setApplyDsbld] = useState(true);
  const [submitResume, setModalResume] = useState(false);
  const openModalResume = () => setModalResume(!submitResume);
  const [modal, setModal] = useState(false);
  const openModal = () => setModal(!modal);
  const [modalOtp, setModalOtp] = useState(false);
  const openModalOtp = () => setModalOtp(!modalOtp);
  const [modalScreen1, setfrstModal] = useState(false);
  const openfrstModal = () => setfrstModal(!modalScreen1);
  const [modalScreen2, setScndModal] = useState(false);
  const openScndModal = () => setScndModal(!modalScreen2);
  const [modalScreen3, setThrdModal] = useState(false);
  const openThrdModal = () => setThrdModal(!modalScreen3);
  const [applybyresume, setModalApplyByResume] = useState(false);
  const openModalApplyResume = () => setModalApplyByResume(!applybyresume);

  /* Job Details */
  const [jobDetails, setJobDetails] = useState([])
  const [jobPostingId, setJPSession] = useState(JSON.parse(sessionStorage.getItem("key")));
  const [idSlctd, setKeySession] = useState(JSON.parse(sessionStorage.getItem("companyId")));
  const [userCol, setUserCol] = useState();
  const [jobDesc, setJobDiscription] = useState("")
  const [skillAndExp, setSkillExpr] = useState([])
  const [responsibility, setResponsibilities] = useState([])
  const [qualifications, setQualifications] = useState([])
  const [companyName, setCompanyName] = useState("")
  const [title, setTitle] = useState("")
  const [companyNumber, setCompNumber] = useState("")
  const [companyEmail, setCompEmail] = useState("")
  const [companyWebsite, setCompPage] = useState("")
  const [companyLocation, setCompanyLocation] = useState("")
  const [landMark, setLocation] = useState("")
  const [employeeIdTmp, setEmployeeId] = useState("")

  /* Job Overview Details */
  const [jobType, setJobType] = useState("")
  const [category, setCategory] = useState("")
  const [jobOverviewLocation, setJobOverviewLocation] = useState("")
  const [offeredSalary, setOfferedSalary] = useState("")
  const [posted, setPosted] = useState("")
  const [experience, setExperience] = useState("")
  const [gender, setGender] = useState("0")
  const [industry, setIndustry] = useState("")
  const [qualification, setQualification] = useState("")
  const [level, setLevel] = useState("")
  const [applied, setApplied] = useState("")
  const [applicationDate, setApplicationDate] = useState("")
  const [companyId, setCompanyId] = useState("")
  const [message, setMessage] = useState("")

  // drop down job overview
  const [_jobDepartment, setJobDepartment] = useState("")
  const [_jobEmploymentType, setEmploymentType] = useState("")
  const [_jobExprnc, setJobExp] = useState("")
  const [_jobQualification, setJobQuali] = useState("")
  const [_jobEducLvl, setJobEducLvl] = useState("")
  const [jobDepartment, setjobDept] = useState([])
  const [employementType, setApplicantType] = useState([])
  const [educLevel, setEdLevel] = useState([])
  const [empJobType, setEmpJobType] = useState([])
  const [jobDetailsPostingId, setPostingJobId] = useState("")
  const [validate, setValidate] = useState("")
  const [emailAdd, setEmail] = useState("")
  const [fullName, setFullName] = useState("")
  const [contactNo, setContactNo] = useState("") 
  const [dataPrivacy, setDataPrivacy] = useState("N")
  const [btnDIsbld, setButtons] = useState(true)
  const [filesResume, setFilePdf] = useState("") 
  const [mdlDataPrvcy, setOpenModalPrivcy] = useState(false)
  const [values, setValues] = useState({
    one             : "",//
    two          : "",//
    three              : "",
    four           : "",//
    five           : "",
    six           : "",
  });
  const [empId, setEmpId] = useState("") 
  const [verified, setVerified] = useState("0") 
  const [isCheckbox, setCheckbox] = useState(true) 
  const [isCompleted, setDataRsitrct] = useState("") 
  const [_createdDate, setCreatedDate] = useState("") 
  const [_endDate, setEnddate] = useState("") 
  const [numberApplcants, SetNumApplicants] = useState("") 
  const [ date , setDate] = useState("")
  const [workingDays, setWorkingDays] = useState("") 
  const [expRequired, setExpRequired] = useState("") 
  const [getWorkLocation, setWorkLocation] = useState("")

  /* Message */
  const [isshow, setisshow] = useState("")
  const [color, setcolor] = useState("")
  const [messageAlert, setmessagealert] = useState("")
  const [fade, setfade] = useState("")
  const [alerttype, setalerttype] = useState("")
    // otp message
  const [isshowotp, setisshowotp] = useState("")
  const [colorotp, setcolorotp] = useState("")
  const [messageAlertotp, setmessagealertotp] = useState("")
  const [fadeotp, setfadeotp] = useState("")
  const [alerttypeotp, setalerttypeotp] = useState("")
  const [companyList, setCompanyList] = useState([]);

  const [jobs, setJobs] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [loaded, setLoaded] = useState(false);



  const [compIndustry, setCompIndustry] = useState("")
  // const [otp, setOtp] = useState([])
  const [otp, setOtp] = useState(Array(length).fill(''));
  const [getOtp, setOTP]= useState("1,2,3,4,5,6")

  useEffect(() => {
    setDate(new Date())
    const isValidate = JSON.parse(sessionStorage.getItem("userCollection"))
    if (isValidate === null){
      setValidate("0")
      setUserCol("")
      setEmployeeId("")
      GetTestRestrict()
    }
    else {
      setValidate("1")
      setUserCol(isValidate[0].userid)
      setEmployeeId(isValidate[0].userid)
      GetTestRestrict(isValidate[0].userid)
    }

    // let alive = true;
    // (async () => {
    //   const [rawJobs, rawCos] = await Promise.all([
    //     getCollection("JobPosting", {}),
    //     getCollection("CompanyProfile", { isDeleted: "0" }),
    //   ]);
    //   if (!alive) return;
    //   const coByCode = {};
    //   rawCos.forEach((c) => { if (c && c.companyCode) coByCode[c.companyCode] = c; });
    //   const mappedJobs = rawJobs
    //     .filter((j) => j && (j.isDeleted == null || j.isDeleted === "0") && j.isClosed !== "1")
    //     .map((j) => mapJob(j, coByCode));
    //   setJobs(mappedJobs);
    //   setCompanyList(rawCos.map((c) => mapCompany(c, mappedJobs)));
    //   GetJobDescription(rawCos.map((c) => mapCompany(c, mappedJobs)));
    //   setLoaded(true);
    // })();
    // return () => { alive = false; };
    
    
    GetCompanyProfile();
  },[]);

  // const parseMongo = (itm) => {
  //   if (itm == null) return null;
  //   if (typeof itm !== "string") return itm;
  //   try {
  //     const cleaned = itm
  //       .replace(/ObjectId\(([^)]*)\)/g, "$1") // ObjectId('..') -> '..' (handles nested)
  //       .replace(/_id/g, "id");
  //     return JSON.parse(cleaned.replace(/'/g, '"'));
  //   } catch (e) {
  //     return null;
  //   }
  // };
  // const getCollection = (collection, filter) =>
  //   axios
  //   .post(AppConfiguration.Setting().jobspaceapi + "action/get", {
  //     _collection: collection,
  //     filter_data: filter || {},
  //   })
  //   .then((res) => 
  //     parseList((res.data || {})[collection])
  //   )
  //   .catch((error) => [
  //     console.error("Error fetching collection:", error)
  // ]);
  // const parseList = (arr) => (Array.isArray(arr) ? arr.map(parseMongo).filter(Boolean) : []);
  // const mapCompany = (itm, jobsArr) => {
  //   const name = itm.companyName || "Company";
  //   return {
  //     name, companyCode: itm.companyCode, ...brandOf(name),
  //     industry: itm.industry || "—",
  //     hq: [itm.city, itm.country].filter(Boolean).map(titleCase).join(", ") || "—",
  //     size: itm.size || "", founded: itm.founded || "—", website: itm.website || "—",
  //     about: itm.about || itm.description || name + " is hiring on JobSpace — follow to get notified about new roles.",
  //     tagline: itm.tagline || name,
  //     openings: jobsArr.filter((j) => j.companyId === itm.companyCode || j.company === name).length,
  //   };
  // };
  // const mapJob = (itm, coByCode) => {
  //   const co = coByCode[itm.companyId] || {};
  //   const company = itm.companyName || co.companyName || "Company";
  //   const lo = peso(itm.salaryCurrency, itm.salaryMin);
  //   const hi = peso(itm.salaryCurrency, itm.salaryMax);
  //   const exp = [itm.experienceMin, itm.experienceMax].filter((x) => x != null && x !== "").join("–");
  //   // Numeric fields used only for filtering/sorting (display is unchanged):
  //   const salNum = Math.max(num(itm.salaryMin) || 0, num(itm.salaryMax) || 0) || null;
  //   const postedMs = itm.createdDate ? Date.parse(itm.createdDate) : NaN;
  //   return {
  //     id: itm.id || itm.postingId, title: itm.title || "Untitled role",
  //     company, companyId: itm.companyId, ...brandOf(company),
  //     location: (co.city ? titleCase(co.city) : itm.workLocation || itm.location) || "—",
  //     type: itm.workType || "Full-time",
  //     salary: lo && hi ? lo + " – " + hi : lo || hi || "Salary undisclosed",
  //     posted: postedLabel(itm.createdDate), easyApply: true,
  //     experience: exp ? exp + " years" : "",
  //     description: itm.description || itm.jobPostingNote || "",
  //     responsibilities: toList(itm.responsibility),
  //     qualifications: toList(itm.qualifications),
  //     benefits: toList(itm.benefits),
  //     salNum, postedAt: isNaN(postedMs) ? null : postedMs,
  //     expMin: num(itm.experienceMin), expMax: num(itm.experienceMax),
  //   };
  // };
  // const LOGO_PALETTE = [
  //   { logoBg: "#e8f0ff", logoColor: "#2563d8" }, { logoBg: "#e6f7ee", logoColor: "#00a862" },
  //   { logoBg: "#eef0ff", logoColor: "#5b3df5" }, { logoBg: "#fff0e6", logoColor: "#e8742a" },
  //   { logoBg: "#eafaf1", logoColor: "#0a9d58" }, { logoBg: "#fff0ec", logoColor: "#ee4d2d" },
  //   { logoBg: "#f1ecff", logoColor: "#7c3aed" }, { logoBg: "#ffecec", logoColor: "#d23b30" },
  // ];
  // const brandOf = (name) => {
  //   const s = (name || "?").trim();
  //   let h = 0;
  //   for (let i = 0; i < s.length; i++) h = (h + s.charCodeAt(i)) % LOGO_PALETTE.length;
  //   return { initial: (s[0] || "?").toUpperCase(), ...LOGO_PALETTE[h] };
  // };
  // const titleCase = (s) => (s || "").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
  // const num = (v) => {
  //   const n = parseFloat(String(v == null ? "" : v).replace(/,/g, ""));
  //   return isNaN(n) ? null : n;
  // };
  // const peso = (cur, v) => {
  //   const n = num(v);
  //   if (n == null) return "";
  //   const sym = /php|peso|₱/i.test(String(cur || "")) || !cur ? "₱" : titleCase(cur) + " ";
  //   return sym + n.toLocaleString("en-PH");
  // };
  // const toList = (v) => {
  //   if (Array.isArray(v)) return v.map((x) => String(x).trim()).filter(Boolean);
  //   if (typeof v === "string") {
  //     const parts = v.split(/\r?\n|•|;/).map((x) => x.trim()).filter(Boolean);
  //     return parts.length ? parts : v.trim() ? [v.trim()] : [];
  //   }
  //   return [];
  // };
  // const postedLabel = (d) => {
  //   if (!d) return "Recently posted";
  //   const t = new Date(d);
  //   if (isNaN(t.getTime())) return "Recently posted";
  //   const days = Math.floor((Date.now() - t.getTime()) / 86400000);
  //   if (days <= 0) return "Posted today";
  //   if (days === 1) return "Posted 1 day ago";
  //   if (days < 7) return "Posted " + days + " days ago";
  //   if (days < 14) return "Posted 1 week ago";
  //   return "Posted " + t.toLocaleDateString("en-PH", { month: "short", day: "numeric" });
  // };

  // const GetCompanyProfile = async() => {

  //   const compId = String(sessionStorage.getItem("companyId"))
    
  //   try {
    
  //     let tempArr = []
  //     let resp = await GetRequest({
  //       url : AppConfiguration.Setting().jobspaceapi + "action/get",
  //       params : {
  //         "dbname"      :  AppConfiguration.Setting().noserJobSpaceDB_Prod,
  //         "_collection" : "CompanyProfile",
  //         "filter_data" : {"isDeleted": "0", /* "userId": compId */},
  //       }
  //     })

  //     // console.log("resp: ", resp.jobPosting.filter((x) => x.title === selJob.title));
  //     if (resp.status!=="1") {
  //       throw new Error("Network response was not ok");
  //     }
  //     // const jobPosting = await resp.json();
  //     console.log("Fetched CompanyProfile:", resp.CompanyProfile);
  //     // console.log("Fetched job posting:", selJob.companyId);
  //   } catch (error) {
  //     console.error("Error fetching CompanyProfile:", error);
  //   }

  // };
  
  const GetCompanyProfile = async() => {

    let filter_data = {"isDeleted": "0"}
    const dataTmp = []

    // // // console.log("1")
    const Params = {

      // "dbname"      :  AppConfiguration.Setting().noserJobSpaceDB_Prod,
      "_collection" : "CompanyProfile",
      "filter_data" : filter_data

    }
    // // // console.log("2")
    axios
    .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
    .then(res => {

      // // // console.log("3")
      let data = res.data

      // // // // console.log("data company prof")
      // // // // console.log(data.CompanyProfile)

      data.CompanyProfile.map(function(itm,i){

        const strJson = itm.replace("","").replace("ObjectId(","").replace(")","").replace("_","")
        const json = JSON.parse(strJson.replace(/'/g,'"'));
        dataTmp.push(json)
        // // // // console.log("json")
        // // // // console.log(json) 

      })   

      // console.log("CompanyProfile")
      // console.log(dataTmp)  

      // setJson(dataTmp)  
      GetJobDescription(dataTmp); 

    })
  };

  const GetJobDescription =async(dataTmp)=> {


    let jobPosting_ = ""

    try{

      let resp = await GetRequest({

        url : AppConfiguration.Setting().jobspaceapi + "action/get",

        params : {

          "dbname"      :  AppConfiguration.Setting().noserJobSpaceDB_Prod,
          "_collection" : "JobPosting",
          "filter_data" : {}

        }

      })

      if(resp.status==="1"){
        console.log("jobPostingId")
        console.log(jobPostingId)

        const jobPostingList = resp.JobPosting.filter(x=>x.postingId===jobPostingId)

        console.log("dataTmp")
        console.log(dataTmp)
        console.log("jobPostingList")
        console.log(jobPostingList)

        const compProfList = dataTmp.filter(x => jobPostingList.some(itm => itm.companyId === x.userId))
        // console.log("compProfList")
        // console.log(compProfList)
        // // // console.log("resp.JobPosting")
        // // // console.log(resp.JobPosting)
        setJobDiscription(jobPostingList[0].description)
        setTitle(jobPostingList[0].title)
        setSkillExpr(jobPostingList[0].skillsExperience)
        setResponsibilities(jobPostingList[0].responsibility)
        setQualifications(jobPostingList[0].qualifications)

        let compTmp = (dataTmp[0].companyName).toLowerCase()
        let toCaseComp = toTitleCase(compTmp)
        setCompanyName(toCaseComp)
        setCompanyId(dataTmp[0].id)
        setJobDetails(resp.JobPosting.filter(x=>x.id===idSlctd))
        setCompNumber(dataTmp[0].mobile)
        let emailTmp = (dataTmp[0].email).toLowerCase()
        let toCaseEmail = toTitleCase(emailTmp)
        setCompEmail(toCaseEmail)
        let webTmp = (dataTmp[0].website).toLowerCase()
        let toCaseWeb = toTitleCase(webTmp)
        setCompPage(toCaseWeb)
        // let _location = compProfList[0].locationUnit + " " + compProfList[0].locationBuilding + " " + compProfList[0].locationStreetNo + " " + compProfList[0].locationStreet + " " + compProfList[0].locationCity + " " + compProfList[0].locationProvince + " " + compProfList[0].locationZipCode
        // setCompanyLocation(_location)
        let landMark = (dataTmp[0].city).toLowerCase() //+ "," + " " + fltrData[0].locationProvince
        // let landMarkTmp = companyProfList[0].email
        let toCaseLandmark = toTitleCase(landMark)
        setLocation(toCaseLandmark)
        let applicationDate = dateFormat(jobPostingList[0].endDate).split(" ")
        // let s1 = applicationDate[0]
        let s2 = applicationDate[1]
        let s3 = applicationDate[2]
        let s4 = applicationDate[3]
        let joinDate = s2 + " " + s3 + ", " + s4
        let spliAppEnd = joinDate
        // // // console.log("compProfList[0]")
        // // // console.log(compProfList[0])
        setApplicationDate(spliAppEnd)
        setWorkLocation(jobPostingList[0].workLocation)

        // let x1 = jobPostingList[0].jobDepartment
        // let x2 = jobPostingList[0].jobTime
        // let x3 = jobPostingList[0].applicantType
        // let x4 = jobPostingList[0].qualifications
        // let x5 = jobPostingList[0].educationalLevel

        // setJobDepartment(x1[0].department)
        // setEmploymentType(x2[0].department)
        // setJobExp(x3[0].ApplicantType)
        // setJobQuali(x4[0].skill)
        // setJobEducLvl(x5[0].educlvl)

        setJobDepartment(jobPostingList[0].dept)
        setEmploymentType(jobPostingList[0].workType)
        setJobExp(jobPostingList[0].aplicantExp)
        let _salaryTmp = toTitleCase(jobPostingList[0].salaryCurrency) + " " + jobPostingList[0].salaryMin + " " + "-" + " " + toTitleCase(jobPostingList[0].salaryCurrency)  + " " + jobPostingList[0].salaryMax
        // let _salaryTmp = jobPostingList[0].salaryMin + " " + "-" + " " + jobPostingList[0].salaryMax
        setOfferedSalary(_salaryTmp)
        // setJobQuali(x4[0].skill)
        setJobEducLvl(jobPostingList[0].education)
        setPostingJobId(jobPostingList[0].postingId)
        setCreatedDate(jobPostingList[0].createdDate)
        setEnddate(jobPostingList[0].endDate)
        setExpRequired(jobPostingList[0].experienceMin)
        // // // console.log("fltrData[0].city")
        // // // console.log(fltrData[0].city)
        // jobPosting_ = jobPostingList[0].postingId
        GetNumOfApplicants(jobPostingList[0].title)
        setWorkingDays(jobPostingList[0].workingDaysAndHrs)
        setCompIndustry(jobPostingList[0].industry)
      }
      // // // console.log()
      // // // console.log()
    }
    catch(error){
      // setMessage(error.message)
      // alert("error: " + error.message)
    }
  };
  const GetNumOfApplicants = async(postingId) => {
    let filter_data = {"title" : postingId}
    const _dataTmp = []
    const Params = {
      // "dbname"      :  AppConfiguration.Setting().noserJobSpaceDB_Prod,
      "_collection" : "Candidates",
      "filter_data" : filter_data
    }
    axios
    .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
    .then(res => {
      let data = res.data
      data.Candidates.map(function(itm,i){
        const strJson = itm.replace("","").replace("ObjectId(","").replace(")","").replace("_","")
        const json = JSON.parse(strJson.replace(/'/g,'"'));
        _dataTmp.push(json)
      })
      // // console.log("postingId")
      // // console.log(postingId)
      SetNumApplicants(String(parseFloat(data.Candidates.length))); 
    })
  };
  const GetTestRestrict = async(empId) => {
    // // // console.log("userCol")
    // // // console.log(typeof userCol === "undefined")
    let fltrUser = ""
    // let _fltrUser = userCol.length===0 || userCol === null ? "" : userCol
    if(typeof empId === "undefined"){
      // // console.log("if")
      fltrUser = ""
    }
    else{
      // // console.log("else")
      fltrUser = empId
    }
    // console.log("empId")
    // console.log(empId)
    let filter_data = {"isDeleted": "0", "userId" : fltrUser}
    const dataTmp = []
    const Params = {
      // "dbname"      :  AppConfiguration.Setting().noserJobSpaceDB_Prod,
      "_collection" : "CandidateRegisteredCheckList",
      "filter_data" : filter_data
    }
    // console.log("Params")
    // console.log(Params)
    axios
    .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
    .then(res => {
      let data = res.data
      if(data.CandidateRegisteredCheckList.length === 0){
        setDataRsitrct("0"); 
      }
      else{
        // let getUserId = JSON.parse(sessionStorage.getItem("userCollection"))
        data.CandidateRegisteredCheckList.map(function(itm,i){
          const strJson = itm.replace("","").replace("ObjectId(","").replace(")","").replace("_","")
          const json = JSON.parse(strJson.replace(/'/g,'"'));
          dataTmp.push(json)
        })       
          
        // setJson(dataTmp)  
        setDataRsitrct(dataTmp[0].basicInfoCandidate); 
        // // console.log("dataTmp")
        // // console.log(dataTmp)
      }
    })
    .catch(error =>{
      // console.log("error")
      // console.log(error)
    })
  };

  function toTitleCase(str) {
    const titleCase = str
      .toLowerCase()
      .split(' ')
      .map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  
    return titleCase;
  }

  
  const onChangeEmail =(e)=>{
    setEmail(e.target.value)
    if(e.target.value!==""){
      setisshow(false)
    }
  }
  const onChangeFullName =(e)=>{
    setFullName(e.target.value)
    if(e.target.value!==""){
      setisshow(false)
    }
  }
  const onChangeContactNo =(e)=>{
    if(e.target.value.length >= 0 && e.target.value.length < 12){
      setContactNo(e.target.value)
    }
    if(e.target.value!==""){
      setisshow(false)
    }
  }
  const onChangeCategory =(e)=>{
    setCategory(e.target.value)
  }
  const onChangeJobOverViewLocation =(e)=>{
    setJobOverviewLocation(e.target.value)
  }
  const onChangeOfferedSalary =(e)=>{
    setOfferedSalary(e.target.value)
  }
  const onChangePosted =(e)=>{
    setPosted(e.target.value)
  }
  const onChangeExperience =(e)=>{
    setExperience(e.target.value)
  }
  const onChangeIndustry =(e)=>{
    setIndustry(e.target.value)
  }
  const onChangeLevel =(e)=>{
    setLevel(e.target.value)
  }
  const onChangeApplied =(e)=>{
    setApplied(e.target.value)
  }
  const onChangeMessage =(e)=>{
    setMessage(e.target.value)
    if(e.target.value!==""){
      setisshow(false)
    }
  }
  const handleChangeDepartmnt=(e)=>{
    setJobDepartment(e.target.value)
  } 
  const handleChangeEmploymentType=(e)=>{
    setEmploymentType(e.target.value)
  } 
  const handleChangeExprnce=(e)=>{
    setJobExp(e.target.value)
  } 
  const handleChangeQualification=(e)=>{
    setJobQuali(e.target.value)
  } 
  const handleChangeEducLvl=(e)=>{
    setJobEducLvl(e.target.value)
  } 
  const onChangeCheckbox=(e)=>{
    // // console.log(e.target.checked)
    if(e.target.checked===true){
      // // alert("checked")
      setDataPrivacy("Y")
      // setCheckbox(false)
      // setApplyDsbld(false)
      if(filesResume==="" && contactNo==="" && fullName==="" && emailAdd===""){
        setButtons(true)
      }
      else {
        setButtons(false)
      }
      if(message===""){
        setApplyDsbld(true)
      }
      else {
        setApplyDsbld(false)
      }
      // setOpenModalPrivcy(true)
      // openModal(openModal)
    }
    else{
      // // alert("not checked")
      setDataPrivacy("N")
      setButtons(true)
      // setCheckbox(true)
      setApplyDsbld(true)
    }
  } 
  const onChangeCheckboxResume=(e)=>{
    // // console.log(e.target.checked)
    if(e.target.checked===true){
      // // alert("checked")
      setDataPrivacy("Y")
      setisshow(false)
      setCheckbox(false)
      // setOpenModalPrivcy(true)
      // openModal(openModal)
    }
    else{
      // // alert("not checked")
      setDataPrivacy("N")
      setCheckbox(true)
    }
  } 
  // const handleChange = (e, index) => {
  //   if (index < length - 1) {
  //     inputs.current[index + 1].focus();
  //   }
  //   const { name, value } = e.target;
  //   setValues({
  //   ...values,
  //   [name]: value
  //   });
  // };
  const onclickVerify = () =>{
    // setVerified("1")
    handleValidateOtp()
    
  }


  const handleApplySignedIn = () =>{
    const dateTmp = moment(date).format('LLLL').split(", ")
    const s1 = dateTmp[1]
    const s2 = dateTmp[2]
    const combDate = s1 + " " + s2
    // // // console.log("combDate")
    // // // console.log(combDate)

    const compCode = JSON.parse(sessionStorage.getItem("userCollection"))

    const newId = getFormattedDateTime();

    const data = {
      newId: newId,
      email : emailAdd,
      name : fullName,
      contact : contactNo,
      message : message,
      jobDepartment : _jobDepartment,
      employementType : _jobEmploymentType,
      experience : _jobExprnc,
      qualification : _jobQualification,
      educLevel : _jobEducLvl,
      expectedSalary : offeredSalary,
      city : landMark,
      industry : "",
      level : "",
      isRegister : "1",
      resume : filesResume,
      dataPrivacy : dataPrivacy,
      postingId : jobDetailsPostingId,
      title : title,
      companyName : companyName,
      companyCode : "",
      employeeId : employeeIdTmp,
      status : "NW",
      createdDate : _createdDate,
      endDate : _endDate,
      jobDocNo : numberApplcants,
      dateApplied : combDate,
      isPhr : "0",

      createdDate : moment(date).format("MM/DD/YYYY"),
      createdBy : employeeIdTmp,
      isModified : "0",
      modifiedDate : moment(date).format("MM/DD/YYYY"),
      modifiedby : employeeIdTmp,
      isDeleted : "0",
      procStatus : "",
      IsProcess : "0",
      dateHired : "",
      remarks : "",
      dateStart : "",
      isResume: filesResume === "" ? "0" : "1",
      jsId : "",
      newIdPic : "",
      newIdResume : "",
    }
    // // console.log("data")
    // // console.log(data)
    
    const params = {
      "_collection" : "Candidates",
      "doc_data" : data
    }

    axios
    .post(AppConfiguration.Setting().jobspaceapi + "action/add", params )
    .then(resp =>{
      // let data = resp.data
      if(resp.data==="success"){
        // sessionStorage.setItem("successdata", JSON.stringify(data))
        // navigateSuccScreen("/SuccessScreen")
      }
      else{
        // console.log("error in line# 539: ")
        // // alert("error")
      }
    })
    .catch(error =>{
      // alert("error: " + error)
    })

    uploadFile();
  }

 
  const uploadFile = () => {
    const newId = getFormattedDateTime();
    // console.log("filesResume:", filesResume); 

    if (!filesResume) {
        // alert("No file selected for upload.");
        return;
    }

    
    const fileToUpload = Array.isArray(filesResume) ? filesResume[0] : filesResume;

    // console.log("fileToUpload:", fileToUpload);
    
    
    if (!fileToUpload || !(fileToUpload instanceof File)) {
        alert("Invalid file selected for upload.");
        return;
    }

    
    const fileName = fileToUpload.name;
    // console.log("File name:", fileName);
    // console.log("Type of fileName:", typeof fileName); 

    
    if (typeof fileName !== 'string') {
        alert("File name is not a valid string.");
        return;
    }

    
    const fileNameParts = fileName.split('.');
    const fileExtension = fileNameParts.pop();
    const fileNameWithoutExtension = fileNameParts.join('.'); 

    const uniqueFileName = `${fileNameWithoutExtension}-${newId}.${fileExtension}`;
    
    const S3_BUCKET = 'job-space-bucket-noser-cdr';
    const REGION = 'us-east-1';
    // const ACCESS_KEY = 'AKIA5HRIKSE2C7YD2NXQ';
    // const SECRET_KEY = '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';

    AWS.config.update({
        accessKeyId: AppConfiguration.Setting().accessKeyId,
        secretAccessKey: AppConfiguration.Setting().secretAccessKey,
        region: REGION,
    });

    const s3 = new AWS.S3();

    const params = {
        Bucket: S3_BUCKET,
        Key: uniqueFileName,
        Body: fileToUpload,
        ACL: 'bucket-owner-full-control',
    };

    // console.log("params:", params);

    s3.upload(params, (err, data) => {
        if (err) {
            // console.log("Error uploading file:", err);
            alert("Error uploading file.");
        } else {
            // console.log("Successfully uploaded file:", data);
            setFilePdf("");
            setFiles(null);
        }
    });
};

  /* start otp config */
  // const handleGenerateOtp = () =>{
  //   if(emailAdd===""){
  //     setalerttype("Danger!")
  //     setisshow(true)
  //     setcolor("danger")
  //     setmessagealert("Please input email address.")
  //     setfade(true)
  //     return

  //   }
  //   else if(fullName===""){
  //     setalerttype("Danger!")
  //     setisshow(true)
  //     setcolor("danger")
  //     setmessagealert("Please input full name.")
  //     setfade(true)
  //     return

  //   }
  //   else if(contactNo===""){
  //     setalerttype("Danger!")
  //     setisshow(true)
  //     setcolor("danger")
  //     setmessagealert("Please input contact no.")
  //     setfade(true)
  //     return

  //   }
  //   else if(message===""){
  //     setalerttype("Danger!")
  //     setisshow(true)
  //     setcolor("danger")
  //     setmessagealert("Please input message.")
  //     setfade(true)
  //     return

  //   }
  //   else if(filesResume===""){
  //     setalerttype("Danger!")
  //     setisshow(true)
  //     setcolor("danger")
  //     setmessagealert("Please upload resume.")
  //     setfade(true)
  //     return

  //   }
  //   else if(dataPrivacy==="N"){
  //     setalerttype("Danger!")
  //     setisshow(true)
  //     setcolor("danger")
  //     setmessagealert("Please accept data privacy!")
  //     setfade(true)
  //     return

  //   }
  //   else{
      
  //     const params = {
  //       "_collection" : "otptran",
  //       "userid" : emailAdd
  //     }

  //     // console.log("params")
  //     // console.log(params)
  //     axios
  //     .post(AppConfiguration.Setting().otpapi + "action/genotp", params )
  //     // .post("http://139.59.239.178:9094/" + "action/genotp", params )
  //     .then(resp =>{
  //       let data = resp.data
  //       setModalOtp(true)
  //       setisshow(false)
  //     })
  //     .catch(error =>{
  //       alert("error: " + error)
  //     })
  //   }

  //   uploadFile();

  // }

  const handleGenerateOtp = () =>{

    setisshowotp(false)

    if(emailAdd===""){
      
      setalerttype("Danger!")
      setisshow(true)
      setcolor("danger")
      setmessagealert("Please input email address.")
      setfade(true)
      return

    }
    else if(fullName===""){
      setalerttype("Danger!")
      setisshow(true)
      setcolor("danger")
      setmessagealert("Please input full name.")
      setfade(true)
      return

    }
    else if(contactNo===""){

      setalerttype("Danger!")
      setisshow(true)
      setcolor("danger")
      setmessagealert("Please input contact no.")
      setfade(true)
      return

    }
    else if(message===""){

      setalerttype("Danger!")
      setisshow(true)
      setcolor("danger")
      setmessagealert("Please input message.")
      setfade(true)
      return

    }
    else if(filesResume===""){

      setalerttype("Danger!")
      setisshow(true)
      setcolor("danger")
      setmessagealert("Please upload resume.")
      setfade(true)
      return

    }
    else if(dataPrivacy==="N"){
      
      setalerttype("Danger!")
      setisshow(true)
      setcolor("danger")
      setmessagealert("Please accept data privacy!")
      setfade(true)
      return

    }
    else{
      
      const params = {
        "_collection" : "otptran",
        "userid" : emailAdd
      }

      // console.log("params")
      // console.log(params)
      axios
      .post(AppConfiguration.Setting().otpapi + "action/genotp", params )
      // .post("http://139.59.239.178:9094/" + "action/genotp", params )
      .then(resp =>{
        let data = resp.data
        const rnd_otp = data.match(/^\d{6}/);
        if (rnd_otp) {
            //// console.log("First six digits:", rnd_otp[0]);
        } else {
            //// console.log("No six-digit number found at the start of 'data'");
        }
        // Send the email with the OTP
        const emailResponse = axios.post(AppConfiguration.Setting().hrisapi+'Mail/SendEmail', {
          ClientId: "1",
          IpAddress: "0.0.0.0",
          Subject: "OTP",
          Body: `
            <html>
              <body>
                <p>Dear User,</p>
                <p>Your One-Time Password (OTP) is: <strong>${rnd_otp}</strong></p>
                <p>Thank you!</p>
              </body>
            </html>
          `,
          ToEmail: [emailAdd],
          CCEmail: [],
        });
        
        setModalOtp(true)
        setisshow(false)
      })
      .catch(error =>{
        // alert("error: " + error)
        // console.log("error: " + error)
      })
    }
  }
  
  

  const handleValidateOtp = () =>{
    let tmpOtp = String(otp).replace('"', "").replace(',', "").replace(',', "").replace(',', "").replace(',', "").replace(',', "")
    const params = {
      "_collection" : "otptran",
      "userid" : emailAdd,
      "userotp" : tmpOtp
    }

    // console.log("params")
    // console.log(params)
    axios
    .post(AppConfiguration.Setting().otpapi + "action/validateotp", params )
    // .post("http://139.59.239.178:9094/" + "action/genotp", params )
    .then(resp =>{
      let data = resp.data
      // console.log("data")
      // console.log(data)
      if(data === 1){
        // // console.log("if")
        setModalOtp(false)
        handleApplyGuest()
      }
      else{
        setalerttypeotp("Danger!")
        setisshowotp(true)
        setcolorotp("danger")
        setmessagealertotp("Invalid OTP.")
        setfadeotp(true)
        setModalOtp(true)
        return
      }
      // // console.log("data")
      // // console.log(data)
    })
    .catch(error =>{
      // alert("error: " + error)
      // console.log("error: " + error)
    })
  }
  /* end otp config */

  const handleApplyGuest = () =>{
    const dateTmp = moment(date).format('LLLL').split(",")
    const s1 = dateTmp[1]
    const s2 = dateTmp[2]
    const combDate = s1 + " " + s2

    const compCode = JSON.parse(sessionStorage.getItem("userCollection"))

    const newId = getFormattedDateTime();

    const data = {
      newId: newId,
      email : emailAdd,
      name : fullName,
      contact : contactNo,
      message : message,
      jobDepartment : _jobDepartment,
      employementType : _jobEmploymentType,
      experience : _jobExprnc,
      qualification : _jobQualification,
      educLevel : _jobEducLvl,
      expectedSalary : offeredSalary,
      city : landMark,
      industry : "",
      level : "",
      isRegister : "0",
      resume : filesResume,
      dataPrivacy : dataPrivacy,
      postingId : jobDetailsPostingId,
      title : title,
      companyName : companyName,
      companyCode : "",
      employeeId : employeeIdTmp,
      status : "NW",
      createdDate : _createdDate,
      endDate : _endDate,
      jobDocNo : numberApplcants,
      dateApplied : combDate,

      createdDate : moment(date).format("MM/DD/YYYY"),
      createdBy : employeeIdTmp,
      isModified : "0",
      modifiedDate : moment(date).format("MM/DD/YYYY"),
      modifiedby : employeeIdTmp,
      isDeleted : "0",
      IsProcess : "0",
      isPhr : "0",
      procStatus : "",
      dateHired : "",
      remarks : "",
      dateStart : "",
      isResume: filesResume === "" ? "0" : "1",
      jsId : "",
      newIdPic : "",
      newIdResume : "",
    }
    // // console.log("data")
    // // console.log(data)
    
    const params = {
      "_collection" : "Candidates",
      "doc_data" : data
    }

    axios
    .post(AppConfiguration.Setting().jobspaceapi + "action/add", params )
    .then(resp =>{
      // let data = resp.data
      if(resp.data==="success"){
        sessionStorage.setItem("successdata", JSON.stringify(data))
        
        navigateSuccScreen("/SuccessScreen")
      }
      else{
        // alert("error")
      }
    })
    .catch(error =>{
      // alert("error: " + error)
    })
    
    uploadFile();

  }

  const handleApplyNoResume = ()=>{
    
    const dateTmp = moment(date).format('LLLL').split(", ")
    const s1 = dateTmp[1]
    const s2 = dateTmp[2]
    const combDate = s1 + " " + s2

    const userData = JSON.parse(sessionStorage.getItem("userCollection"))
    let nameTmp = userData[0].firstName + " " + userData[0].lastName



    const newId = getFormattedDateTime();

    const data = {
      newId: newId,
      email : userData[0].email,
      name : nameTmp,
      contact : contactNo,
      message : message,
      jobDepartment : _jobDepartment,
      employementType : _jobEmploymentType,
      experience : _jobExprnc,
      qualification : _jobQualification,
      educLevel : _jobEducLvl,
      expectedSalary : offeredSalary,
      city : landMark,
      industry : "",
      level : "",
      isRegister : "1",
      resume : "",
      dataPrivacy : dataPrivacy,
      postingId : jobDetailsPostingId,
      title : title,
      companyName : companyName,
      companyCode : "",
      employeeId : userData[0].userid,
      status : "NW",
      createdDate : _createdDate,
      endDate : _endDate,
      jobDocNo : numberApplcants,
      dateApplied : combDate,

      createdDate : moment(date).format("MM/DD/YYYY"),
      createdBy : employeeIdTmp,
      isModified : "0",
      modifiedDate : moment(date).format("MM/DD/YYYY"),
      modifiedby : employeeIdTmp,
      isDeleted : "0",
      IsProcess : "0",
      isPhr : "0",
      procStatus : "",
      dateHired : "",
      remarks : "",
      dateStart : "",
      isResume: "0",
      jsId : "",
      newIdPic : "",
      newIdResume : "",
    }
    // // console.log("data")
    // // console.log(data)
    
    const params = {
      "_collection" : "Candidates",
      "doc_data" : data
    }

    axios
    .post(AppConfiguration.Setting().jobspaceapi + "action/add", params )
    .then(resp =>{
      // let data = resp.data
      if(resp.data==="success"){
        sessionStorage.setItem("successdata", JSON.stringify(data))
        navigateSuccScreen("/SuccessScreen")
      }
      else{
        // alert("error")
      }
    })
    .catch(error =>{
      // alert("error: " + error)
    })
  }
  const NavigateSignIn=()=>{
    // // // console.log(companyId)
    // // // console.log(jobPostingId)
    sessionStorage.setItem("companyId", JSON.stringify(companyId))
    sessionStorage.setItem("key", JSON.stringify(jobPostingId))
    // // // console.log(jobPostingId)
    navigateSignIn("/signin");
  }
  const NavigateSignUp=()=>{
    // // // console.log(companyId)
    // // // console.log(jobPostingId)
    // sessionStorage.setItem("companyId", JSON.stringify(companyId))
    // sessionStorage.setItem("key", JSON.stringify(jobPostingId))
    // // // console.log(jobPostingId)
    navigateSignUp("/signup");
  }
  const handleNavigateProfile = () =>{
    navigateCandidProf("/CandidateProfileApplication");
  }
  const NavigateJobPost = () =>{
    navigateJobPost("/JobDetailsDescription");
    setThrdModal(false)
  }
  // const UploadResume=(e)=>{
  //   // // console.log(e.target.files[0])
  //   if(typeof e.target.files[0] === "undefined"){
  //     setFilePdf("")
  //     setisshow(false)
  //   }
  //   else {
  //     setFilePdf(e.target.files[0].name)
  //   }
  // }

  const UploadResume = (e) => {
    setisshow(false)

    const allowedTypes = [
      "application/pdf", // pdf
      "application/msword", // .doc
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document" // .docx
    ];

    const selectedFile = e.target.files[0];
    // const file = e.target.files[0];
    if (!selectedFile) return; // No file selected

    // Validate file type
    if (!allowedTypes.includes(selectedFile.type)) {
      setalerttype("Danger!")
      setisshow(true)
      setcolor("danger")
      setmessagealert("Only PDF or Word documents (.doc, .docx) are allowed.")
      setfade(true)
      e.target.value = ""; // Reset file input
      return;
    }

    if (selectedFile) {
      setFilePdf(selectedFile);
      setFile(selectedFile);
      // console.log("File uploaded:", selectedFile.name);
    } else {
      setFile(null);
    }
  };

  


  
  const handleChangeSwitch =(e)=>{
  }
  const handleOpenModal =(e)=>{
    setfrstModal(false)
    setScndModal(true)
  }
  const handleOpenModal2 =(e)=>{
    setScndModal(false)
    setThrdModal(true)
  }
  const handleOpenResume =(e)=>{
    // setScndModal(false)
    setThrdModal(false)
    // setModalResume(true)
    navigateDirectApply("/ApplyCompProf")
  }
  const handleDirectbyResume =()=>{
    // setfrstModal(false)
    // setCheckbox(true)
    // setDataPrivacy("N")
    // setFilePdf("")
    // setModalApplyByResume(true)
    navigateResume("/ApplyResume")
  }

  const handleChange = (e, index) => {
    const { value } = e.target;

    if (value.match(/^\d$/)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (index < length - 1) {
        inputs.current[index + 1].focus();
      }
    }

    if (value === '' && index > 0) {
      inputs.current[index - 1].focus();
    }
  };
  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      if (index > 0) {
        e.preventDefault();
        inputs.current[index - 1].focus();
      }
      // console.log("Backspace")
      // console.log(index )
      if(index === 5){
        setOTP(otp[5] = "")
        inputs.current[index].value = ""
      }
      if(index === 4){
        setOTP(otp[4] = "")
        inputs.current[index].value = ""
      }
      if(index === 3){
        setOTP(otp[3] = "")
        inputs.current[index].value = ""
      }
      if(index === 2){
        setOTP(otp[2] = "")
        inputs.current[index].value = ""
      }
      if(index === 1){
        setOTP(otp[1] = "")
        inputs.current[index].value = ""
      }
      if(index === 0){
        setOTP(otp[0] = "")
        inputs.current[index].value = ""
      }
    }
  };
  return (
    <div className="jsa-root" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", background: "#f4f7f4", minHeight: "100vh", color: "#16271f", paddingBottom: 40 }}>
      <div style={{ maxWidth: 1180, margin: "0 auto", padding: "96px 24px 0" }}>
          {isshow && (
            <div style={{ position: "fixed", top: 84, right: 20, maxWidth: "25vw", width: "max-content", zIndex: 100 }}>
              <Alert isOpen={isshow} color={color} fade={fade} style={{ margin: 0, paddingRight: 38, wordBreak: "break-word", boxShadow: "0 8px 24px rgba(20,50,38,.18)" }}>
              <div className={color}></div> 
            <b>{messageAlert}</b>
                <button type="button" aria-label="Close" onClick={() => setisshow(false)} style={{ position: "absolute", top: 8, right: 10, border: "none", background: "transparent", fontSize: 18, lineHeight: 1, cursor: "pointer", color: "inherit", opacity: 0.6 }}>×</button>
          </Alert>
                </div>
          )}
          <div style={{ marginBottom: 24 }}>
            <p style={{ margin: 0, fontSize: 14, fontWeight: 600, color: "#6b7770" }}>Applying for</p>
            <h1 style={{ margin: "6px 0 4px", fontSize: 26, fontWeight: 800, letterSpacing: "-.02em", color: "#16271f" }}>{title}</h1>
            <p style={{ margin: 0, fontSize: 16, fontWeight: 600, color: "#009b57" }}>{companyName}</p>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 20, marginTop: 12 }}>
              <span style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 14, color: "#6b7770" }}>
                <i className="mdi mdi-map-marker"></i>{landMark}
              </span>
              <span style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 14, color: "#6b7770" }}>
                <i className="mdi mdi-clock"></i>{workingDays}
              </span>
                </div>
            </div>
          <Row>
            <Col lg={5}>
                        // placeholder="Employment Type"
              <div style={{ background: "#fff", border: "1px solid #e8ede9", borderRadius: 14, padding: 24, boxShadow: "0 1px 2px rgba(20,50,38,.04)" }}>
                <h5 style={{ margin: "0 0 16px", fontSize: 15, fontWeight: 800, color: "#16271f" }}>Job Overview</h5>
                        // onChange={onChangeOfferedSalary}
                {[
                  ["Employment Type", _jobEmploymentType],
                        // placeholder="Industry"
                  ["Industry", compIndustry],
                        // placeholder="Location"
                  ["Location", getWorkLocation],
                        // onChange={onChangeJobOverViewLocation}
                        // placeholder="Offered Salary"
                  ["Offered Salary", offeredSalary],
                        // onChange={onChangeCategory}
                        // placeholder="Department"
                  ["Department", _jobDepartment],
                        // disabled={true}
                        // onChange={onChangeJobType}
                  ["Experience", expRequired],
                ].map(([k, v]) => (
                        // placeholder="Experience"
                  <div key={k} style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 16, padding: "10px 0", borderBottom: "1px solid #f0f3f1" }}>
                    <span style={{ fontSize: 13, fontWeight: 600, color: "#6b7770" }}>{k}</span>
                    <span style={{ fontSize: 14, fontWeight: 600, color: "#16271f", textAlign: "right" }}>{v || "—"}</span>
                  </div>
                ))}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 16, padding: "10px 0" }}>
                  <span style={{ fontSize: 13, fontWeight: 600, color: "#6b7770" }}>Number of applicants</span>
                  <span style={{ fontSize: 14, fontWeight: 700, color: "#009b57" }}>{numberApplcants}</span>
                </div>
                <div style={{ marginTop: 16, paddingTop: 16, borderTop: "1px solid #f0f3f1" }}>
                  <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: "#16271f" }}>{jobDetailsPostingId}</p>
                  <p style={{ margin: "4px 0 0", fontSize: 13, color: "#6b7770" }}>Application ends: <b style={{ color: "#16271f" }}>{applicationDate}</b></p>
                </div>
              </div>
            </Col>
            <Col lg={5}  style={{marginTop: "-0.9%"}}>
              <Row>
                <Col>
                {validate === "1"? 
                  <p className="mb-2" style={{fontSize: 15, fontWeight: 700, color: "#16271f"}}>
                    Cover letter
                  </p>
                  :
                  <p className="mb-2" style={{fontSize: 15, fontWeight: 700, color: "#16271f"}}>
                    Provide the details to apply for the job
                  </p>
                }
                  <Card style={{ backgroundColor: "#fff", borderRadius: 14, border : "1px solid #e8ede9", boxShadow: "0 1px 2px rgba(20,50,38,.04)"}}>
                    <CardBody style={{padding: 24}}>
                      <Row style={{marginTop: "-3%"}}>
                      {validate === "1"? null:
                        <Input
                          type="text"
                          className="form-control"
                          id="nameControlInput"
                          placeholder="E-mail Address"
                          style={{ color: "#16271f" }}
                          value={emailAdd}
                          onChange={onChangeEmail}
                        />
                      }
                      </Row>
                      <Row className="mt-2">
                        {validate === "1"? null:
                          <Input
                            type="text"
                            className="form-control"
                            id="nameControlInput"
                            placeholder="Full Name"
                            style={{ color: "#16271f" }}
                            value={fullName}
                            onChange={onChangeFullName}
                          />
                        }
                      </Row>
                      <Row className="mt-2">
                        {validate === "1"? null:
                          <Input
                            type="number"
                            className="form-control"
                            id="nameControlInput"
                            placeholder="Contact Number"
                            style={{ color: "#16271f" }}
                            value={contactNo}
                            // maxLength={11}
                            maxLength="11"
                            onChange={onChangeContactNo}
                          />
                        }
                      </Row>
                      <Row className="mt-2">
                        {/* <Label className="form-label" for="inputGroupFile01" style={{fontWeight: "bold"}}>
                        Message
                        </Label> */}
                        <Input
                          type="textarea"
                          className="form-control"
                          id="nameControlInput"
                          placeholder="Message"
                          style={{ color: "#16271f" }}
                          value={message}
                          onChange={onChangeMessage}
                          rows={7}
                          // aria-rowspan={3}
                        />
                      </Row>
                      <Row className="mt-2">
                        <Col sm={1}>
                          <Input
                            style={{border: "1px solid green"}}
                            className="form-check-input"
                            type="checkbox"
                            id="flexCheckDefault"
                            // to="otpscreen"
                            onClick={e =>onChangeCheckbox(e)}
                          />
                        </Col>
                        <Col lg={11}>
                        {validate === "0"? 
                          <p className="text-muted mb-0" style={{ textAlign: "justify", fontSize : "9px", marginLeft : "-5%"}}>
                            By uploading your resume and apply for this job, you agreed to our 
                            <b style={{color: "#0A6219"}} to ="datapolicy" onClick={openModal}> Data Privacy Policy </b>
                            of collecting, storing and using your personal data as described in our policy 
                            to matches the candidate skill needed by the employers. 
                          </p>
                          :
                          <p className="text-muted mb-0" style={{ textAlign: "justify", fontSize : "14px", marginLeft : "-4%"}}>
                            When you apply for this job, your JobSpace profile including any verified credentials will be accessed by the employer. Other employers and recruiters
                            can also approach you with job opportunities based on your profile access settings.
                          </p>
                        }
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                  <Row>
                  <div className="mb-1 mt-1">
                    <Row>
                      {validate === "0"? 
                        <Input
                          type="file"
                          className="form-control"
                          id="inputGroupFile01"
                          onChange={UploadResume}
                        />:
                        null
                      }
                    </Row>
                  </div>
                  </Row>
                        {validate === "0"? 
                    <div style={{ marginTop: 20 }}>
                      <button type="submit" to="otpscreen" onClick={handleGenerateOtp} className="jsa-btn-primary" style={{ width: "100%", padding: "12px 22px", fontSize: 15 }}>
                            Submit Application
                          </button>
                      <div style={{ display: "flex", alignItems: "center", gap: 14, margin: "16px 0" }}>
                        <div style={{ flex: 1, height: 1, background: "#e8ede9" }} />
                        <span style={{ fontSize: 13, color: "#9aa89f", fontWeight: 600 }}>or</span>
                        <div style={{ flex: 1, height: 1, background: "#e8ede9" }} />
                      </div>
                      <button type="submit" onClick={NavigateSignIn} className="jsa-btn-ghost" style={{ width: "100%", padding: "12px 22px", fontSize: 15 }}>
                        Sign in to apply
                          </button>
                      <p style={{ textAlign: "center", margin: "14px 0 0", fontSize: 14, color: "#6b7770" }}>
                        Don't have an account?{" "}
                        <span onClick={NavigateSignUp} style={{ color: "#009b57", fontWeight: 700, cursor: "pointer" }}>Register</span>
                      </p>
                    </div>
                        :
                    <div style={{ marginTop: 20 }}>
                      <button type="submit" disabled={applydisbled} onClick={openfrstModal} className="jsa-btn-primary" style={{ width: "100%", padding: "12px 22px", fontSize: 15 }}>
                          Apply
                        </button>
                    </div>
                      }
                </Col>
              </Row>
              <Row className="mt-2">
              </Row>
              {/* {validate === "0"? 
              <Row className="mt-2">
                <Col>
                  <Row className="mt-2" style={{marginLeft: "0.1%", marginRight : "0.1%"}}>
                    <button
                      type="submit" 
                      className="btn"
                      style={{backgroundColor: "#E0FDDB", alignContent: 'center'}}
                      // onClick={()=>alert("clicked")}
                    >
                      <b>Continue with Google</b>
                    </button>
                  </Row>
                  <Row className="mt-2" style={{marginLeft: "0.1%", marginRight : "0.1%"}}>
                    <button
                      type="submit" 
                      className="btn"
                      style={{backgroundColor: "#E0FDDB", alignContent: 'center'}}
                      // onClick={()=>alert("clicked")}
                    >
                      <b>Continue with Facebook</b>
                    </button>
                  </Row>
                  <Row className="mt-2" style={{marginLeft: "0.1%", marginRight : "0.1%"}}>
                    <button
                      type="submit" 
                      className="btn"
                      style={{backgroundColor: "#E0FDDB", alignContent: 'center'}}
                      // onClick={()=>alert("clicked")}
                    >
                      <b>Continue with Apple</b>
                    </button>
                  </Row>
                </Col>
              </Row>
              : 
              null
              } */}
            </Col>
            <Col lg={2}></Col>
          </Row>
      </div>
      {/* Modals */}
      <div
        className="modal fade"
        id="otpscreen"
        tabIndex="-1"
        aria-labelledby="otpscreen"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <Modal isOpen={modalOtp} toggle={openModalOtp} centered>
            <ModalBody className="modal-body p-5" style={{ backgroundColor: "#F0FEED"}}>
              <div className="position-absolute end-0 top-0 p-3">
                <button
                  type="button"
                  onClick={openModalOtp}
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <Alert isOpen={isshowotp} color={colorotp} fade={fadeotp} className={isshowotp ? 'display-block' : 'display-none'} style={{maxWidth: "100%"}}>
                  <div className={color}></div> 
                <b>{messageAlertotp}</b>
              </Alert>
              <Row>
                <h4 className="mb-1" style={{color: "#000000"}}>
                  Verify your application
                </h4>
              </Row>
              <Row>
                <h5 className="mb-1 mt-2" style={{fontSize: "14px", color: "#000000"}}>
                  Email Address
                </h5>
              </Row>
              <Card className="mt-4">
                <CardBody>
                  <Row className="mt-3">
                    <Col sm={10} className="mb-1"  style={{fontSize: "14px", color: "#000000"}}>
                      <label>We have sent an OTP to your</label>
                    </Col>
                    {/* <Col sm={2}>
                      <label><u style={{color: "green", fontSize: 14,textAlign: "right"}}>Change</u></label>
                    </Col> */}
                  </Row>
                  <Row /* className="mt-1" */>
                    <Col sm={12} className="mb-1" style={{fontSize: "14px", color: "#000000"}}>
                      <label>{/* mobile number */}Email &nbsp;&nbsp;&nbsp; <b style={{color: "green"}}><u> {emailAdd} </u></b></label>
                    </Col>
                  </Row>
                  <Row className="mt-4">
                  <Col sm={12} className="mb-1" style={{fontSize: "14px", color: "#000000"}}>
                    Enter OTP
                  </Col>
                  </Row>
                  {<FormGroup>
                    {otp.map((_, index) => (
                      <input
                        key={index}
                        type="text"
                        maxLength="1"
                        value={otp[index]}
                        onChange={(e) => handleChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        ref={(el) => (inputs.current[index] = el)}
                        style={{
                          width: '40px',
                          height: '40px',
                          margin: '0 5px',
                          textAlign: 'center',
                          fontSize: '18px',
                          border: '1px solid #ccc',
                          borderRadius: '4px',
                        }}
                      />
                    ))}
                  </FormGroup>}
                  <Row>
                    <Form.Text className="mb-1"  style={{fontSize: "14px", color: "#000000"}}>  &nbsp;&nbsp;&nbsp;&nbsp;Didn't receive your OTP? <Button onClick={() => {handleGenerateOtp(); setmessagealertotp("OTP sent to your email please check."); setisshowotp(true); setfadeotp(true); setcolorotp("success"); setalerttype("Success!"); setOtp(['', '', '', '', '', '']);}}  variant="link" className="text-decoration-underline" style={{color: "green"}}>Resend</Button></Form.Text>
                  </Row>
                  <Row>
                  <Col sm={12}>
                    <button 
                      className="btn btn-success noser-button-md"
                      style={{minWidth : "45%"}}
                      // variant="success"
                      onClick={onclickVerify}
                    > 
                      Verify Email
                    </button>
                  </Col>
                  
                  </Row>
                </CardBody>
              </Card>
            </ModalBody>
          </Modal>
        </div>
      </div>
      <div
        className="modal fade"
        id="datapolicy"
        tabIndex="-1"
        aria-labelledby="datapolicy"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <Modal isOpen={modal} toggle={openModal} centered>
            <ModalBody className="modal-body p-5" style={{backgroundColor: "#F0FEED"}}>
              <div className="position-absolute end-0 top-0 p-3">
                <button
                  type="button"
                  onClick={openModal}
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <Row>
                <h9 style={{color: "#00000", fontSize : "14px", fontWeight: "bolder", textAlign: "center"}}>
                  DATA PRIVACY POLICY
                </h9>
              </Row>
              <p style={{marginTop: "6%", textAlign:"justify", fontSize : "14px",}}>
                We believe you should be able to access and control your personal information no matter where you live. Depending on how you use JobSpace, you may have the
                right to request access to, correct, amend, delete, restrict, or object to certain uses of your personal information.

                <div style={{marginTop: "3%"}}></div>
                We will not charge you more or provide you with a different level of service if you exercise any of these rights, Please note that a number of these rights
                apply only in certain circumstances, and all of these rights may be limited by law.

                <div style={{marginTop: "3%"}}></div>
                We will retain your personal data only as long as necessary to fulfill the purposes for which we have collected it. To determine the appropriate retension period,
                we consider the amount, nature and sensitivity of your personal data, the potential risk of harm from unauthorized use or disclosure of your personal data,
                the purposes for which we process your personal data and whether we can achieve those purposes through other means and the applicable legal requirements.

                <div style={{marginTop: "3%"}}></div>
                We will also retain and use your personal information to extent necessary to comply with our legal obligations, resolve disputes and enforce our policies.

                <div style={{marginTop: "3%"}}></div>
                If you stop using our services or if you delete your account with us, we will delete your information or store your information in an aggregated and anonymized format.

              </p>
              <Row>
                <Col sm={3}>
                </Col>
                <Col sm={3}>
                  <label style={{fontSize: "14px", fontWeight : "bolder", marginTop: "3%"}}>
                    I Agree
                  </label>
                </Col>
                <Col sm={5}>
                  <Switch
                    checked={true}
                    onChange={handleChangeSwitch}
                    // onClick={()=>handleClickSwitch()}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                </Col>
                <Col sm={1}>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
        </div>
      </div>
      <div
        className="modal fade"
        id="modalScreen1"
        tabIndex="-1"
        aria-labelledby="modalScreen1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <Modal isOpen={modalScreen1} toggle={openfrstModal} centered>
            <ModalBody className="modal-body p-5">
              <div className="position-absolute end-0 top-0 p-3">
                <button
                  type="button"
                  onClick={openfrstModal}
                  className="btn-close"
                  data-bs-dismiss="modalScreen1"
                  aria-label="Close"
                ></button>
              </div>
              <Row>
                <h5 className="text-muted mb-1" style={{fontSize: "14px"}} /* style={{marginLeft: "10%"}} */>
                  <b>Continue your applications via</b>
                </h5>
              </Row>
              <Card style={{backgroundColor: "#F0FEED"}}>
                <CardBody>
                  <Row>
                    <Col lg={3}>
                    </Col>
                    <Col lg={7}>
                    { isCompleted === "0" ? 
                      <button type="submit" className="btn mt-5 noser-button-md" onClick={handleOpenModal} style={{ minWidth : "10%", textAlign: "center", backgroundColor : "#F0FEED", borderColor: "green", borderWidth: 2, borderRadius: 10, fontWeight: "bold"}}>
                        JobSpace Profile
                      </button>
                      : 
                      <button type="submit" className="btn mt-5 noser-button-md" onClick={openModalResume} style={{ minWidth : "10%", textAlign: "center", backgroundColor : "#F0FEED", borderColor: "green", borderWidth: 2, borderRadius: 10, fontWeight: "bold"}}>
                        JobSpace Profile
                      </button>
                    }
                    </Col>
                    <Col lg={2}>
                    </Col>
                  </Row>
                  <Row >
                    <p className="text-muted mb-1" style={{textAlign: "center", fontSize: "14px"}}>Your full JobSpace profile will be visible to the employer</p>
                  </Row>
                  <Row>
                    <Col sm={3}>
                    </Col>
                    <Col sm={7} >
                      <button type="submit" className="btn mt-5 noser-button-md" onClick={handleDirectbyResume} style={{ minWidth : "10%", textAlign: "center", backgroundColor : "#F0FEED", borderColor: "green", borderWidth: 2, borderRadius: 10, fontWeight: "bold"}}>
                        Resume Upload
                      </button>
                    </Col>
                    <Col sm={2}>
                    </Col>
                  </Row>
                  <Row >
                    <p className="text-muted mb-1" style={{textAlign: "center", fontSize: "14px"}}>Let your resume apply for you, Your Uploaded file</p><br />  
                    <p className="text-muted mb-1" style={{textAlign: "center", fontSize: "14px"}}>will be sent to the employers</p>
                  </Row>
                </CardBody>
              </Card>
            </ModalBody>
          </Modal>
        </div>
      </div>
      <div
        className="modal fade"
        id="modalScreen2"
        tabIndex="-1"
        aria-labelledby="modalScreen2"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <Modal isOpen={modalScreen2} toggle={openScndModal} centered>
            <ModalBody className="modal-body p-5">
              <div className="position-absolute end-0 top-0 p-3">
                <button
                  type="button"
                  onClick={openScndModal}
                  className="btn-close"
                  data-bs-dismiss="modalScreen2"
                  aria-label="Close"
                ></button>
              </div>
              <Card style={{backgroundColor: "#F0FEED"}}>
                <CardBody>
                  <Row sm={12}>
                    <p className="text-muted mb-1" style={{textAlign:"justify", fontWeight: "bolder", justifyContent: "center", fontSize: "14px"}}>You still need to fill out other needed details in your profile. This might not make your application stand-out.</p>
                  </Row>
                  <Row className="mt-3">
                    <p className="text-muted mb-1" style={{textAlign: "center", fontWeight: "bolder", fontSize: "14px"}}>Do you want to proceed your application?</p>  
                  </Row>
                  <Row className="mt-5">
                    <Col sm={1}>
                    </Col>
                    <Col sm={10}>
                      <button type="submit" className="btn btn-success" onClick={handleOpenResume} style={{minWidth : "20%", textAlign: "center", marginLeft: "20%"}}>
                        Yes
                      </button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <button type="submit" className="btn btn-success" onClick={handleOpenModal2} style={{minWidth : "20%", textAlign: "center"}}>
                        No
                      </button>
                    </Col>
                    <Col sm={1}>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </ModalBody>
          </Modal>
        </div>
      </div>
      <div
        className="modal fade"
        id="modalScreen3"
        tabIndex="-1"
        aria-labelledby="modalScreen3"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <Modal isOpen={modalScreen3} toggle={openThrdModal} centered>
            <ModalBody className="modal-body p-5">
              <div className="position-absolute end-0 top-0 p-3">
                <button
                  type="button"
                  onClick={openThrdModal}
                  className="btn-close"
                  data-bs-dismiss="modalScreen3"
                  aria-label="Close"
                ></button>
              </div>
              <Card style={{backgroundColor: "#F0FEED"}}>
                <CardBody>
                  <Row className="mt-3">
                    <p className="text-muted mb-1" style={{textAlign: "center", fontWeight: "bolder", fontSize: "14px"}}>Do you want to proceed editing your profile?</p>  
                  </Row>
                  <Row className="mt-5">
                    <Col sm={2}>
                    </Col>
                    <Col sm={9}>
                      <button type="submit" className="btn btn-success" onClick={handleNavigateProfile} style={{minWidth : "20%", textAlign: "center"}}>
                        Yes, continue
                      </button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <button type="submit" className="btn btn-success" onClick={NavigateJobPost} style={{minWidth : "20%", textAlign: "center"}}>
                        No
                      </button>
                    </Col>
                    <Col sm={1}>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </ModalBody>
          </Modal>
        </div>
      </div>
      <div
        className="modal fade"
        id="submitResume"
        tabIndex="-1"
        aria-labelledby="submitResume"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <Modal isOpen={submitResume} toggle={openModalResume} centered>
            <ModalBody className="modal-body p-5">
              <div className="position-absolute end-0 top-0 p-3">
                <button
                  type="button"
                  onClick={openModalResume}
                  className="btn-close"
                  data-bs-dismiss="submitResume"
                  aria-label="Close"
                ></button>
              </div>
              <Row>
                <h5 className="text-muted mb-1" style={{ fontSize: "14px"}}>
                  <b>Applying for</b>
                </h5>
                <Col md={8}>
                  <h2 className="mt-3" style={{color:"#376837"}}>{title}</h2>
                  <h5 className="mb-1">{companyName}</h5>
                </Col>
              </Row>
              <Row>
                <div className="mt-3 mt-lg-0">
                  <li className="list-inline-item">
                    <p className="text-muted mb-0" style={{ fontSize: "14px"}}>
                      <i className="mdi mdi-map-marker"></i>{" "}
                      {getWorkLocation}
                    </p>
                  </li>
                </div>
              </Row>
              <Row>
                <div className="mt-3 mt-lg-0">
                  <li className="list-inline-item">
                    <p className="text-muted mb-0" style={{ fontSize: "14px"}}>
                      <i className="mdi mdi-clock"></i>{" "}
                      {_jobEmploymentType}
                    </p>
                  </li>
                </div>
              </Row>
              <div className="mb-4 mt-5">
                {/* <Input
                  type="file"
                  className="form-control"
                  id="inputGroupFile01"
                  onChange={UploadResume}
                /> */}
              </div>
                <button type="submit" className="btn btn-success mt-5" onClick={handleApplyNoResume} style={{textAlign: "center", marginLeft: "30%"}}>
                  Submit Application
                </button>
            </ModalBody>
          </Modal>
        </div>
      </div>
      <div
        className="modal fade"
        id="applybyresume"
        tabIndex="-1"
        aria-labelledby="applybyresume"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <Modal isOpen={applybyresume} toggle={openModalApplyResume} centered>
            <ModalBody className="modal-body p-5">
              <div className="position-absolute end-0 top-0 p-3">
                <button
                  type="button"
                  onClick={openModalApplyResume}
                  className="btn-close"
                  data-bs-dismiss="applybyresume"
                  aria-label="Close"
                ></button>
              </div>
              <Row>
                <Input
                  type="file"
                  className="form-control"
                  id="inputGroupFile01"
                  onChange={UploadResume}
                />
              </Row>
              <Row lg={12} className="mt-2">
                <Col lg={1}>
                  <Input
                    style={{border: "1px solid green"}}
                    className="form-check-input"
                    type="checkbox"
                    id="flexCheckDefault"
                    // to="otpscreen"
                    onClick={e =>onChangeCheckboxResume(e)}
                  />
                </Col>
                <Col lg={11}>
                  <p className="text-muted mb-0" style={{ fontSize: "9px", textAlign: "justify", marginLeft: "-12%"}}>
                    By uploading your resume and apply for this job, you agreed to our 
                    <b style={{color: "#0A6219"}} to ="datapolicy" onClick={openModal}> Data Privacy Policy </b>
                    of collecting, storing and using your personal data as described in our policy 
                    to matches the candidate skill needed by the employers. 
                  </p>
                </Col>
              </Row>
              <button type="submit" disabled={isCheckbox} className="btn btn-success mt-5" onClick={handleApplySignedIn} style={{minWidth : "20%", textAlign: "center", marginLeft: "30%"}}>
                Submit Resume
              </button>
            </ModalBody>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default ApplicationPage;